require('./cardActivationR42Step2.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { nonNumericFilter } = require('utilities/stringHelper');

// @ components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

// @ constants
const {
    CARD_ACTIVATION_ID,
    MULTIPLE_OPERATIONS,
    TRAVEL_PLUS_HIRE,
} = require('constants/operationTypes');
const { CARD_ACTIVATION_ID_CC } = require('constants/contactCenter/operationTypes');

class CardActivationR42Step2 extends React.Component {
    render() {
        const {
            immCard,
            travelPlusActivated,
        } = this.props;
        const operationTypeActivateCard = __CONTACT_CENTER__ ? CARD_ACTIVATION_ID_CC : CARD_ACTIVATION_ID;
        const pan = nonNumericFilter(immCard.get('number'));

        let operationType = operationTypeActivateCard;
        let operationParams = {
            pan,
        };

        if (travelPlusActivated) {
            operationType = MULTIPLE_OPERATIONS;
            operationParams = {
                id: '',
                requestMulti: [
                    {
                        serviceCode: operationTypeActivateCard,
                        pan,
                    },
                    {
                        serviceCode: TRAVEL_PLUS_HIRE,
                        pan,
                    },
                ]
            };
        }

        return (
            <article className="card-activation-r42-step-2">
                <FormattedText
                    className="card-activation-r42-step-2__title"
                    value="cardActivationR42-cardActivationR42_confirmationStepTitle"
                />
                <div className="card-activation-r42-step-2__message">
                    <OKMessage
                        type="important"
                    >
                        <FormattedText
                            value="cardActivationR42-cardActivationR42_confirmationStepMessage"
                        />
                    </OKMessage>
                </div>
                <SignaturePattern
                    operationParams={operationParams}
                    operationType={operationType}
                />
            </article>
        );
    }
}

CardActivationR42Step2.propTypes = {
    immCard: PropTypes.object.isRequired,
    travelPlusActivated: PropTypes.bool.isRequired,
};

module.exports = CardActivationR42Step2;
